import { DIVISIONS } from "../../lib/api";

export const ReviewFilter = ({ value, onChange, counts, total }) => {
  const tabs = [{ key: "all", label: "All Divisions", n: total }, ...DIVISIONS.map((d) => ({ key: d.key, label: d.short, n: counts[d.key] || 0 }))];
  return (
    <div className="flex flex-wrap gap-2 mb-10" role="tablist" data-testid="reviews-division-filter">
      {tabs.map((t) => (
        <button key={t.key} type="button" role="tab" aria-selected={value === t.key} onClick={() => onChange(t.key)}
          className={`px-4 py-2 text-xs font-mono uppercase tracking-wider border transition-colors duration-200 ${value === t.key ? "border-[var(--gold)] bg-[var(--gold)] text-[#0a0d14]" : "border-white/15 text-slate-300 hover:border-[var(--gold)] hover:text-gold"}`}
          data-testid={`reviews-filter-${t.key}`}>
          {t.label} <span className="opacity-70 ml-1">{t.n}</span>
        </button>
      ))}
    </div>
  );
};
